export const SELF = '$self'
export const MY_STATE = '$state'
